export default {
  pt: {
    pageTitle: "Contratar",
    mainTitle: "O que você vai proteger?",
    description: "Selecione a categoria para continuarmos.",
    bikeButton: "BICICLETA",
    scooterButton: "SCOOTER",
  },

  en: {
    pageTitle: "Contract",
    mainTitle: "What are you going to protect?",
    description: "Select your vehicle category to continue.",
    bikeButton: "BICYCLE",
    scooterButton: "SCOOTER",
  },
};
